// SPDX-License-Identifier: AGPL-3.0-or-later
//
// parley: the two soundboard dispatches (strand AG). Registered in
// features/gateway/events/EventRouter.ts, the same seam the E2EE key
// update uses.

import SoundboardPlaybackEngine from '@app/parley/soundboard/SoundboardPlaybackEngine';
import SoundboardStore, {type ApiSoundboardSound} from '@app/parley/soundboard/SoundboardStore';
import type {GatewayHandlerContext} from '@app/features/gateway/events/EventRouter';
import {Logger} from '@app/features/platform/utils/AppLogger';
import MediaEngine from '@app/features/voice/engine/MediaEngineFacade';

const logger = new Logger('SoundboardEvents');

interface GuildSoundboardSoundsUpdatePayload {
	guild_id: string;
	soundboard_sounds: ReadonlyArray<ApiSoundboardSound>;
}

interface SoundboardSoundPlayPayload {
	user_id: string;
	channel_id: string;
	guild_id: string;
	sound_id: string;
	name: string;
	volume: number;
	hash: string;
	url: string;
	duration_ms: number;
	content_type: string;
}

export function handleGuildSoundboardSoundsUpdate(
	data: GuildSoundboardSoundsUpdatePayload,
	_context: GatewayHandlerContext,
): void {
	SoundboardStore.handleSoundsUpdate(data.guild_id, data.soundboard_sounds ?? []);
}

export function handleSoundboardSoundPlay(data: SoundboardSoundPlayPayload, _context: GatewayHandlerContext): void {
	// Only play it while we are in that very channel: the dispatch goes to
	// everyone with a voice state there, and a stale one must stay silent.
	if (!MediaEngine.connected || MediaEngine.channelId !== data.channel_id) {
		logger.debug('Ignoring a soundboard sound for a channel we are not in', {
			eventChannelId: data.channel_id,
			localChannelId: MediaEngine.channelId,
		});
		return;
	}
	void SoundboardPlaybackEngine.play({
		userId: data.user_id,
		hash: data.hash,
		url: data.url,
		durationMs: data.duration_ms,
		volume: data.volume,
	});
}
